define('plugins/musicfavourite/nls/standard',[
    './standard/button',
    './standard/confirmation',
    './standard/dialog'
], function(button, confirmation, dialog) {
    return {
        button: button,
        confirmation: confirmation,
        dialog: dialog
    };
});
